import { Button, DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEmailSettings extends Layout {
    buttonTestEmailSettings: Button;
    labelSettingsTitle: Label;
    sourceEmailSettings: DataSource;
    textboxEmail: Textbox;
    textboxEmailBcc: Textbox;
    textboxEmailClient: Textbox;
    textboxEmailHost: Textbox;
    textboxEmailPassword: Textbox;
    textboxEmailPort: Textbox;
    textboxEmailProtocol: Textbox;
    textboxEmailUsername: Textbox;
}
